import { useMutation } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { logger } from "@/core/utils/func/logger";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type {
  WalletResolveByPhoneRequest,
  WalletResolveByPhoneResponse,
} from "@/features/wallet/api/dto";

/**
 * Résolution d'un portefeuille principal par numéro E.164
 * (`POST /Wallets/resolve-by-phone`, guide v2.4 §6.3).
 *
 * À brancher sur la saisie de bénéficiaire d'un transfert interne : debounce
 * côté UI (300-500 ms), affichage du `displayName`. Codes : 422 inconnu, 429
 * quota (par appelant).
 */
export const useResolveWalletByPhone = () =>
  useMutation({
    mutationKey: ["wallet", "wallets", "resolveByPhone"],
    mutationFn: (body: WalletResolveByPhoneRequest) =>
      mutateData({
        url: walletEndpoints.walletsExt.resolveByPhone,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<WalletResolveByPhoneResponse>,
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.debug(
        `useResolveWalletByPhone rejection: ${message}`,
        { prefix: "wallet" }
      );
    },
  });
